module.exports = __webpack_public_path__ + "static/media/ExempliGratia.1b59684d.png";